// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_root__1K308","cardsWrapper":"Dashboard_cardsWrapper__b2Dta","card":"Dashboard_card__3Es5m"};